import { InjectionToken } from '@angular/core';
import { MojoAvatarConfigService, MojoAvatarDownloadService } from 'mojo-avatar';
import { NEVER, Observable } from 'rxjs';

export const AVATAR_DOWNLOAD_SERVICE = new InjectionToken<MojoAvatarDownloadService>(
  'AvatarDownloadService',
);
export const AVATAR_CONFIG_SERVICE = new InjectionToken<MojoAvatarConfigService>(
  'AvatarConfigService',
);

export class AvatarDownloadService implements MojoAvatarDownloadService {
  // eslint-disable-next-line
  download({ id }: { id: string | number }): Observable<Blob> {
    // TODO: implement when there will be requirement to display user photos
    return NEVER;
  }
}
